// const { pad } = require("lodash");

const panels = document.querySelectorAll('.js-render-panel');

const targets = document.querySelectorAll('.js-render-target');

panels.forEach((panel,i) => {
  panelEvent(panel,i)
});

targets.forEach((target,i) => {
  targetEvent(target,i)
});


function panelEvent(panel,i) { 
  panel.addEventListener("mouseover", ()=> {
    targets[i].classList.add('is-render');
  });
  panel.addEventListener("mouseout", ()=> {
    targets[i].classList.remove('is-render');
  });
}

function targetEvent(target,i) { 
  target.addEventListener("mouseover", ()=> {
    panels[i].classList.add('is-render');
  });
  target.addEventListener("mouseout", ()=> {
    panels[i].classList.remove('is-render');
  });
}